import { render } from "./Notifications.vue?vue&type=template&id=aa26bfbc&scoped=true"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"

import "./Notifications.vue?vue&type=style&index=0&id=aa26bfbc&lang=scss&scoped=true"

import exportComponent from "/var/www/miniapp-property-b2b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa26bfbc"],['__file',"src/assets/js/components/Notifications.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "aa26bfbc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('aa26bfbc', __exports__)) {
    api.reload('aa26bfbc', __exports__)
  }
  
  module.hot.accept("./Notifications.vue?vue&type=template&id=aa26bfbc&scoped=true", () => {
    api.rerender('aa26bfbc', render)
  })

}


export default __exports__